module.exports = __webpack_public_path__ + "img/logo-secretaria.2db66d3c.png";